import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { chunkString } from "@poscon/shared-types";
import { useDispatch } from "react-redux";
import { useOptionContainerPos } from "../hooks/useOptionContainerPos.js";
import { usePixiOnClickOutside } from "../hooks/usePixiOnClickOutside.js";
import { useOnMount } from "../hooks/useOnMount.js";
import { eramTextDimensionMap } from "../../eramFont.js";
import { MenuElement } from "./MenuElement.js";
import { colorNameMap } from "../../colorNameMap.js";
import { setSelectedViewOption } from "../slices/commonSlice";
import { setCursorPosition } from "../../cursor.js";
import { useWindowSize } from "usehooks-ts";
const { width: fontWidth, height: fontHeight } = eramTextDimensionMap[2];
export const ViewItemOptionContainer = ({ baseX = 0, baseY = 0, xOffset = 0, yOffset = 0, options, borderTint = colorNameMap.grey, maxRowWidth, closeOnClickOutside = true, }) => {
    const dispatch = useDispatch();
    const windowSize = useWindowSize();
    const ref = useRef(null);
    const defaultSelectionRef = useRef(null);
    const _maxWidth = Math.max(...options.map(({ text }) => text.length)) * fontWidth + 4;
    const maxWidth = maxRowWidth ? Math.min(maxRowWidth, _maxWidth) : _maxWidth;
    const height = options.reduce((acc, { text }) => acc + chunkString(text, Math.floor(maxWidth / fontWidth), true).length * (fontHeight + 1), 0);
    const { x, y } = useOptionContainerPos(ref, maxWidth, height, xOffset + 1, yOffset, { x: baseX, y: baseY });
    usePixiOnClickOutside(ref, () => {
        if (closeOnClickOutside) {
            dispatch(setSelectedViewOption(null));
        }
    });
    useOnMount(() => {
        const cursorRepositionElem = defaultSelectionRef.current ?? ref.current;
        if (window.__TAURI__ && cursorRepositionElem) {
            const rect = cursorRepositionElem.getBounds();
            const yOverflow = Math.max(0, rect.y + height + 1 - windowSize.height);
            const newCursorPos = {
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2 - yOverflow,
            };
            if (rect.right > window.innerWidth) {
                newCursorPos.x -= xOffset + rect.width;
            }
            void setCursorPosition(newCursorPos.x, newCursorPos.y);
        }
    });
    let elemY = 0;
    const defaultSelectionIndex = options.findIndex((o) => o.isDefaultSelection);
    return (_jsx("container", { x: x, y: y, ref: ref, eventMode: "static", zIndex: 5, sortableChildren: true, children: options.map(({ text, onmousedown, bgColor, tint, disabled }, index) => {
            const _y = elemY;
            const chunkedText = chunkString(text, Math.floor(maxWidth / fontWidth), true);
            const height = fontHeight * chunkedText.length;
            elemY += height;
            return (_jsx(MenuElement, { ref: index === defaultSelectionIndex ? defaultSelectionRef : undefined, textX: 2, text: chunkedText.join("\n"), x: 0, y: _y, disabled: disabled, width: maxWidth, height: height, onmousedown: onmousedown, fillColor: bgColor, borderColor: borderTint, tint: tint }, index));
        }) }));
};
export function createItemOption(text, onmousedown, opts = {
    bgColor: colorNameMap.darkGrey,
    tint: colorNameMap.lightGrey,
    disabled: false,
    isDefaultSelection: false,
}) {
    if (opts.disabled && !opts.tint) {
        opts.tint = colorNameMap.mediumGrey;
    }
    return {
        text,
        onmousedown,
        ...opts,
    };
}
//# sourceMappingURL=ViewItemOptionContainer.js.map